<template>
  <div>
    <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>主页</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">当天不良品项分布</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>

       <!-- 搜索筛选 -->
       <el-form :model="form" class="user-search" label-width="80px" size="small">
        <!-- <el-row>
          <el-col :span="8">
            <el-form-item label="时间">
              <el-date-picker
                popper-class="order-create-picker"
                style="width: 100%;"
                :clearable="false"
                v-model="form.planTime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="3">
            <el-button size="small" type="primary" style="margin-left: 10px;" icon="el-icon-search" @click="search">查询</el-button>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="6">
            <el-form-item label="产品编号">
              <el-input size="small" v-model="form.productCode" placeholder="请输入产品编号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="产品名称">
              <el-input size="small" v-model="form.productName" placeholder="请输入产品名称" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="产品规格">
              <el-input size="small" v-model="form.specs" placeholder="请输入产品规格" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="产品属性">
              <el-select
                v-model="form.source"
                clearable
                filterable
                placeholder="请选择"
                style="width:100%;"
              >
                <el-option
                  v-for="item in orderStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="2" class="text-align-right">
            <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-col>
        </el-row>

      </el-form>
    </div>

    <div class="white-background">
        <el-row class="tbl-btn">
          <el-col :span="12" class="tbl-btn-left">
            <el-button size="small" type="primary" icon="el-icon-upload2" @click="createProduct">导出</el-button>
            <!-- <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="small" type="primary" plain icon="el-icon-download">导入</el-button>
            <el-button size="small" type="primary" plain icon="el-icon-upload2">导出</el-button>
            <el-button type="text" icon="el-icon-s-data" @click="viewImportLog">查看导入日志</el-button>
            <el-button type="text" icon="el-icon-edit-outline">编辑打印模板</el-button>
            <el-button type="text" icon="el-icon-tickets">自定义事件</el-button> -->
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
            <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
        </el-row>
        <el-table
        ref="tableData"
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
          @selection-change="handleTblSelectionChange"
          row-key="_id"
        >
          <el-table-column align="left" type="selection" width="60" :reserve-selection="true"></el-table-column>
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>
          <el-table-column label="产品编号" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productCode" placement="top">
                <span class="txt-overflow">{{scope.row.productCode}}</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column label="产品名称" width="150">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.productName" placement="top">
                <span class="txt-overflow">{{scope.row.productName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="specs" label="产品规格" width="100"></el-table-column>
          <el-table-column prop="technologyCode" label="工艺路线" width="100"></el-table-column>
          <el-table-column prop="unit" label="单位" width="90"></el-table-column>
          <el-table-column prop="stockNum" label="库存数量" width="100"></el-table-column>
          <el-table-column prop="maxStock" label="最大库存" width="100"></el-table-column>
          <el-table-column prop="minStock" label="最小库存" width="100"></el-table-column>
          <el-table-column prop="safeStock" label="安全库存" width="100"></el-table-column>
          <el-table-column prop="source" label="产品属性" width="100" ></el-table-column>
          <el-table-column v-for="item in setList" :key="item._id" :prop="item.fieldName" :label="item.fieldName"></el-table-column>

          <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
          <el-table-column prop="deptNo" label="创建人" width="100"></el-table-column>
          <el-table-column prop="updateTime" label="最后更新时间" width="140"></el-table-column>

        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      </div>

  </div>
</template>
<script>

import { productGetList ,productDelete,productBatchDelete} from '@/api/basicData';
import {queryAllCustomSet} from '@/api/business';
import Pagination from "@/components/Pagination";

export default {
  name: "NoGoodDistribution",
  components:{
      Pagination
  },
  data() {
    return {
      form: {},
      orderStatusList: [
        {
          label: "自制",
          value: "自制"
        },
        {
          label: "外购",
          value: "外购"
        },
        {
          label: "委外",
          value: "委外"
        }
      ],
      isFold: true,
      listData: [],
      loading: false,
      isBatchPrint: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      createProductPanVisible:false,
      isMain:true,
      menuName:{
        first:'基础数据',
        second:'产品定义',
        three:'导入日志',
      },
      userData:{},
      editRow:{},
      mode:'',
      sourceList:[{
        label:'自制',
        value:'0'
      },{
        label:'外购',
        value:'1'
      },{
        label:'委外',
        value:'2'
      }],
      setList:[],
    };
  },
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
      this.init();

    }
  },
  methods: {
    init(){
       queryAllCustomSet(this.userData.factoryId,'product').then(res=>{
        this.setList = [];
        if(res['code'] == 200){
          this.setList = res['data'];
          this.search();
        }
      })
    },
    fold() {
      this.isFold = !this.isFold;
    },
    search() {
      this.loading = true
      var data = {
        condition: {
          factoryId: this.userData.factoryId,
          productCode:this.form.productCode,
          productName:this.form.productName,
          specs:this.form.specs,
          source:this.form.source,
          minStock:this.form.minStock,
          maxStock:this.form.maxStock,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      productGetList(data).then(res => {
        if(res.code == 200){
          this.listData = res.data.list
          this.loading = false
        }
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    /**
     * 监听表格选中项变化事件
     */
    handleTblSelectionChange(val) {
      this.tblSelectionList = val;
    },
    handleDelete(index,row){
      this.$confirm('确认删除产品？操作将同时删除关联的物料清单，删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        productDelete(row._id).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.search()
          } else {
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(function(){})
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          productBatchDelete(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    handleEdit(index,row){
      this.mode = 'edit'
      this.editRow = row
      this.createProductPanVisible = true
    },
     // 分页插件事件
    callFather(parm) {
    },
    createProduct(){
      this.mode = 'create'
      this.editRow = {}
      this.createProductPanVisible = true;
    },
    productSave(options){
        if(options.type == 'save'){
          this.search()
        }
        this.createProductPanVisible =false;

    },
    viewImportLog(){
      this.isMain = !this.isMain;
    },
    goBack(){
      this.isMain = !this.isMain;
    },
    productFormat(val){
      var res = this.sourceList.filter(function(item){
        return item.value == val.source
      })
      if(res && res.length!=0){
        return res[0].label
      }
    },
  }
};
</script>
<style scoped>
.page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/home/report/NoGoodDistribution.vue